var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,20,10)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.457,32.5C31.804,29.208 35.653,27.06 40,27.06C44.347,27.06 48.196,29.208 50.543,32.5",
    style: {
      fill: "none",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.543,47.5C48.197,50.792 44.347,52.94 40,52.94C35.653,52.94 31.804,50.792 29.457,47.5",
    style: {
      fill: "none",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.41,32.5C34.344,30.543 37.03,29.33 40,29.33C42.969,29.33 45.655,30.543 47.59,32.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.59,47.5C45.655,49.457 42.969,50.67 40,50.67C37.03,50.67 34.344,49.457 32.41,47.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.802,32.5C29.415,27.915 34.349,24.82 40,24.82C45.651,24.82 50.585,27.915 53.198,32.5",
    style: {
      fill: "none",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.198,47.5C50.585,52.086 45.651,55.18 40,55.18C34.349,55.18 29.415,52.086 26.802,47.5",
    style: {
      fill: "none",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.419,32.504C22.482,24.104 30.546,18.1 40,18.1C49.453,18.1 57.515,24.102 60.58,32.5",
    style: {
      fill: "none",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.582,47.496C57.518,55.896 49.455,61.9 40,61.9C30.547,61.9 22.485,55.898 19.42,47.5",
    style: {
      fill: "none",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.05565,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.369,43.112C27.697,43.112 28.513,42.48 28.513,41.424C28.513,40.536 27.929,40.008 26.537,39.68C25.681,39.48 25.385,39.264 25.385,38.92C25.385,38.552 25.713,38.328 26.249,38.328C26.833,38.328 27.185,38.632 27.185,39.136L28.409,39.136C28.409,38.008 27.561,37.288 26.233,37.288C24.945,37.288 24.145,37.92 24.145,38.944C24.145,39.856 24.761,40.4 26.073,40.68C26.865,40.848 27.225,41.08 27.225,41.472C27.225,41.848 26.889,42.064 26.361,42.064C25.745,42.064 25.345,41.752 25.345,41.216L24.097,41.216C24.097,42.376 24.961,43.112 26.369,43.112ZM32.221,43L33.493,43L33.493,38.592L35.269,38.592L35.269,37.4L30.445,37.4L30.445,38.592L32.221,38.592L32.221,43ZM36.572,43L37.932,43L38.308,42.032L40.532,42.032L40.908,43L42.268,43L40.044,37.4L38.796,37.4L36.572,43ZM38.636,41.032L39.42,38.984L40.212,41.032L38.636,41.032ZM44.616,43L45.888,43L45.888,41.256L46.728,41.256L47.728,43L49.2,43L48.04,41.056C48.712,40.76 49.104,40.152 49.104,39.328C49.104,38.136 48.288,37.4 47.008,37.4L44.616,37.4L44.616,43ZM45.872,40.184L45.872,38.488L46.84,38.488C47.464,38.488 47.816,38.792 47.816,39.336C47.816,39.88 47.464,40.184 46.84,40.184L45.872,40.184ZM52.966,43L54.238,43L54.238,38.592L56.014,38.592L56.014,37.4L51.19,37.4L51.19,38.592L52.966,38.592L52.966,43Z",
    style: {
      fill: "rgb(198,207,213)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68,40C68,35.861 64.639,32.5 60.5,32.5L19.5,32.5C15.361,32.5 12,35.861 12,40C12,44.139 15.361,47.5 19.5,47.5L60.5,47.5C64.639,47.5 68,44.139 68,40Z",
    style: {
      fill: "none",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,40C79.5,18.199 61.801,0.5 40,0.5C18.199,0.5 0.5,18.199 0.5,40C0.5,61.801 18.199,79.5 40,79.5C61.801,79.5 79.5,61.801 79.5,40Z",
    style: {
      fill: "none",
      stroke: "rgb(232,237,240)",
      strokeWidth: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.1dd375c4.svg";
export { ForwardRef as ReactComponent };